<template>
  <v-container>
    <spring-spinner class="centered" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SpringSpinner from '@/components/spinners/SpringSpinner'

export default {
  components: { SpringSpinner },
  computed: {
    ...mapGetters(['user', 'notificationSubscriptionId'])
  },
  methods: {
    setAxiosHeaders() {
      const token = this.$store.getters.accessToken

      this.$axios.interceptors.request.use(config => {
        if (config.url.startsWith('/')) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      })
    }
  },
  created() {
    let data
    this.$store
      .dispatch('handleAuthentication')
      .then(({ id, authResult }) => {
        data = authResult

        window.xCacheKey = id

        return this.$store.dispatch('getUser', id)
      })
      .then(() => {
        this.$store.dispatch('setUser', {
          ...this.user,
          notificationSubscriptionId: this.notificationSubscriptionId
        })

        this.$store.dispatch('putUser')
        this.setAxiosHeaders()

        const target =
          !data.appState || data.appState.to === '/login'
            ? '/'
            : data.appState.to

        this.$router.replace(target)
      })
      .catch(err => {
        this.$store.dispatch(
          'showErrorSnackbar',
          err.message || 'Something went wrong'
        )
      })
  }
}
</script>

<style scoped>
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
